import { OrderingInitialState, SetCouponAction } from '@reducers/ordering/types';

export const setCoupon = (state: OrderingInitialState, action: SetCouponAction): OrderingInitialState => ({
  ...state,
  couponState: {
    ...state.couponState,
    coupon: action.payload,
  },
});
